import React, { Fragment } from 'react';
import { withRouter } from 'react-router-dom'
import { useStateIfMounted } from 'use-state-if-mounted'
const { useState, useEffect, useRef } = React;
import { Paper, Typography } from '@mui/material';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { faClosedCaptioning } from '@fortawesome/free-solid-svg-icons';
const style = {
    position: 'absolute',
    top: '40%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 800,
    bgcolor: 'background.paper',
    border: 'px solid #000',
    boxShadow: 24,
    p: 4,
    color: 'black',
};
const ModalDetalleMarcas = (props) => {


    let texto = props.texto
    const { api = undefined } = props
    const { VerModalDetalle, dataDetalle, detalleMarcas = undefined } = api
    /******Modal */
    const [openModal, setOpenModal] = React.useState(detalleMarcas);
    const [titleModal, setTitleModal] = React.useState('');
    const [bodyModal, setBodyModal] = React.useState('')
    const [accion, setAccion] = React.useState('')

    const handleCloseModal = () => {
        setTitleModal('')
        setBodyModal('')
        setAccion('')
        setOpenModal(false)
        VerModalDetalle(false)
        //resetValores({ validacion: false, texto: '' })
    }
 
    return (
            <Modal open={openModal} onClose={handleCloseModal} aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description" hideBackdrop={true} >
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h6" component="h2" style={{ color: "black", textAlign: 'center' }}>
                        Detalle de marca
                    </Typography>
                    <Typography id="modal-modal-description" component="h2" sx={{ mt: 2 }} style={{ color: "black", textAlign: 'center' }}>
                        <Fragment>
                            <table className="table table-bordered">
                                <thead className='text-center labelNaranja'>
                                    <tr>
                                        <th >Dato</th>
                                        <th >Descripcion</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className='text-start'> Marca Registrada: </td>
                                        <td className='text-start'>{dataDetalle.marcaregistrada}</td>
                                    </tr>
                                    <tr>
                                        <td className='text-start'> Nombre de la marca: </td>
                                        <td className='text-start'> {dataDetalle.nombremarca}</td>
                                    </tr>
                                    <tr>
                                        <td className='text-start'> Numero de registro: </td>
                                        <td className='text-start'> {dataDetalle.numeroregistro} </td>
                                    </tr>
                                    <tr>
                                        <td className='text-start'> Tipo de marca: </td>
                                        <td className='text-start'> {dataDetalle.tipomarca} </td>
                                    </tr>
                                    <tr>
                                        <td className='text-start'> Titularidad de la marca: </td>
                                        <td className='text-start'> {dataDetalle.titularidad} </td>
                                    </tr>
                                    <tr>
                                        <td className='text-start'> Productor autorizado: </td>
                                        <td className='text-start'> {dataDetalle.productorautorizado} </td>
                                    </tr>
                                    <tr>
                                        <td className='text-start'> Maquilador autorizado: </td>
                                        <td className='text-start'> {dataDetalle.maquiladorautorizado} </td>
                                    </tr>
                                </tbody>
                            </table>
                        </Fragment>
                    </Typography>
                    <br />
                    <div className='text-center'>
                        <button className={`btn btn-success`} type='button' style={{ width: '50%' }} onClick={() => handleCloseModal()}>Cerrar</button>
                    </div>
                </Box>
            </Modal>
    )
};

export default withRouter(ModalDetalleMarcas)
